import { Button, Modal, Form, Radio, Select, message, Input, DatePicker, Space, Switch, Tooltip } from 'antd';
import { PlusOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import React, { useState, useEffect } from 'react';
import { CREATE_TOWER_PROJECT, CHANGE_TOWER_PROJECT } from '../../constants/tower-constants';
import './index.less';
import apis from '@/apis/room/index';
import ComponentLog from '@/components/component-log';
import { CJ_LISTEN_YXHD_YMDJ } from '@/constants/scene';
import FeedBackLayout from '@/components/feedback-layout';
import __ from 'lodash';
import env from '@/env/env.prod';
import Copy from '@/components/copy';

interface CreateTowerProjectProps {
  type: number;
  roomId?: string | null;
  refresh?: () => void | undefined;
}

const { Option } = Select;
const { RangePicker }: any = DatePicker;

function CreateTowerProject({ type, roomId, refresh }: CreateTowerProjectProps) {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [value, setValue] = useState(type === CREATE_TOWER_PROJECT ? 2 : 1);
  const [towerList, setTowerList] = useState([]);
  const [platform, setPlatform] = useState(1);
  const [activityType, setActivityType] = useState(1);
  const [recommendFlag, setRecommendFlag] = useState(true);
  const [errorMessage, setErrorMessage] = useState(false);
  const [errorInfo, setErrorInfo] = useState({ roomName: '', roomId: '', owner: '' });
  const [form] = Form.useForm();
  const ref = React.useRef();

  const modalTitle = (function () {
    switch (type) {
      case CREATE_TOWER_PROJECT:
        return '新建通天塔项目';
      case CHANGE_TOWER_PROJECT:
        return '更换通天塔项目';
    }
  })();

  const onChange = (e: any) => {
    setValue(e.target.value);
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    form.submit();
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    form.resetFields();
    setValue(type === CREATE_TOWER_PROJECT ? 2 : 1);
    setErrorMessage(false);
  };

  const handleSearch = (searchStr: string) => {
    apis
      .validTowerList({ searchStr: searchStr })
      .then(({ ret, data, msg }: any) => {
        if (ret === '0') {
          setTowerList(data);
        } else {
          message.error(msg);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const onFinish = (values: any) => {
    if (value === 3) {
      Modal.confirm({
        content: '确定要取消关联当前通天塔项目?',
        onOk() {
          apis
            .associateTower({
              roomId: roomId,
              opt: 3,
            })
            .then(({ ret, msg }: any) => {
              if (ret === '0') {
                form.resetFields();
                setIsModalVisible(false);
                setValue(type === CREATE_TOWER_PROJECT ? 2 : 1);
                typeof refresh === 'function' && refresh();
                message.success('取消成功');
              } else {
                message.error(msg);
              }
            })
            .catch((e) => {
              console.log(e);
            });
        },
      });
      return;
    }
    const { towerName, time, towerId } = values;
    const towerActivityInfo = {
      towerName,
      startTime: time ? new Date(time[0]).getTime() : undefined,
      endTime: time ? new Date(time[1]).getTime() : undefined,
      recommendFlag: recommendFlag ? 1 : 2,
      activityType,
      platform,
    };
    const conditions = (function () {
      if (value === 2) {
        return {
          roomId,
          opt: 2,
          towerActivityInfo: towerActivityInfo,
          type: 2,
        };
      } else {
        return {
          roomId,
          opt: value,
          towerId: towerId,
          type: 2,
        };
      }
    })();

    apis
      .associateTower({
        ...conditions,
      })
      .then(({ ret, msg }: any) => {
        if (ret === '0') {
          //@ts-ignore
          ref.current.show(true);
          value === 2 && message.success('新建成功');
          value === 1 && message.success('更新成功');
          form.resetFields();
          setIsModalVisible(false);
          setValue(type === CREATE_TOWER_PROJECT ? 2 : 1);
          typeof refresh === 'function' && refresh();
        } else {
          message.error(msg);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  useEffect(() => {
    apis
      .validTowerList()
      .then(({ ret, data, msg }: any) => {
        if (ret === '0') {
          setTowerList(data);
        } else {
          message.error(msg);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);

  const CreateItem = () => (
    <>
      {/*@ts-ignore*/}
      <Form.Item
        label="项目名称"
        name="towerName"
        rules={[
          {
            required: true,
            message: '请输入项目名称',
          },
        ]}
      >
        <Input style={{ width: 200 }} placeholder="请输入项目名称" />
      </Form.Item>
      <Form.Item
        label="生效时间"
        name="time"
        rules={[
          {
            required: true,
            message: '请输入生效时间',
          },
        ]}
      >
        <RangePicker showTime />
      </Form.Item>
      <Form.Item>
        <Space>
          <Switch
            checkedChildren="开"
            unCheckedChildren="关"
            style={{ marginLeft: 20 }}
            checked={recommendFlag}
            onChange={(v: any) => {
              setRecommendFlag(v);
            }}
          />
          <div>
            广告外投资源位承接
            <Tooltip
              placement="right"
              overlayStyle={{ minWidth: 500 }}
              title={
                <div style={{ height: 400, overflow: 'scroll' }}>
                  <img
                    width={465}
                    src="//img10.360buyimg.com/imagetools/jfs/t1/187173/35/21394/25546/612f5e66E6610d03c/75eb5e32973cef3a.jpg"
                  />
                  <p>1. 什么情况下需要开启?</p>
                  <p>如后期该活动会参与京准通投放（包括站内外）、首焦报名或大促会场入口报名，需要开启。</p>
                  <p>2. 开启有什么效果?</p>
                  <p>开启后，项目下新增活动页均自动添加“联动商品”楼层。</p>
                  <p>
                    该楼层仅在广告投放及首焦渠道展示（其他渠道不展示），展示商品为广告投放提报的商品，及同品类下针对用户相关行为进行的相关推荐数据。实现与广告、首焦入口图的商品联动展示，提高内外一致性，进而提高订单转化率。
                  </p>
                  <p>3. 开启后如何取消展示联动楼层?</p>
                  <p>开启后，添加的联动楼层仍可在每个子页面下自行编辑及删除。</p>
                  <p>为保证和入口的联动效果，一行三样式建议联动商品楼层放置在活动页首屏3-8楼层位置。</p>
                  <p>浮层样式无楼层数限制，默认会出现在活动页左下角，用户无点击10s后会自消失，以免打扰用户浏览页面。</p>
                </div>
              }
            >
              <QuestionCircleOutlined style={{ marginLeft: 5 }} />
            </Tooltip>
          </div>
        </Space>
      </Form.Item>
      <Form.Item label="项目类型">
        <Space direction="horizontal">
          <Select
            defaultValue="1"
            style={{ width: 150 }}
            showSearch
            onChange={(v: any) => {
              setPlatform(Number(v));
            }}
          >
            <Option value="1">通用</Option>
          </Select>
          <Select
            defaultValue="1"
            style={{ width: 150 }}
            onChange={(v: any) => {
              setActivityType(Number(v));
            }}
          >
            <Option value="1">活动</Option>
            <Option value="2">频道</Option>
          </Select>
          <span style={{ paddingLeft: 20 }}>
            请按实际使用场景选择
            <Tooltip
              placement="rightBottom"
              title={
                <div>
                  <div>
                    活动:具有短期时效性且有明显促销性质的营销活动页;部分二级品类活动活动频次较高，长期使用同一链接上线不同活动，也归于活动类;商家搭建也归属此类。
                  </div>
                  <div>
                    频道:长期维护的，一般具有固定入口、固定名称、固定展示结构和内容的品类集合营销页面。如需使用频道关注功能，请选择“频道”且不可切换。
                  </div>
                </div>
              }
            >
              <QuestionCircleOutlined />
            </Tooltip>
          </span>
        </Space>
      </Form.Item>
    </>
  );

  return (
    <>
      {/* @ts-ignore */}
      <FeedBackLayout showFeedBack={true} scene={CJ_LISTEN_YXHD_YMDJ.key} ref={ref} />
      {type === CREATE_TOWER_PROJECT && (
        <ComponentLog clstag="resource_1627030927203|54">
          <Button type="primary" onClick={showModal}>
            <PlusOutlined />
            新增通天塔项目
          </Button>
        </ComponentLog>
      )}
      {type === CHANGE_TOWER_PROJECT && (
        <ComponentLog clstag="resource_1627030927203|56">
          <a onClick={showModal} style={{ marginLeft: 20 }}>
            更换通天塔项目
          </a>
        </ComponentLog>
      )}
      <Modal
        title={
          <>
            <span className="create-tower-project__first-title">{modalTitle}</span>
            <span className="create-tower-project__second-title">同一个会场下只能有一个通天塔项目</span>
          </>
        }
        width={650}
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <Form form={form} onFinish={onFinish}>
          {
            <Form.Item label="选择方式">
              <Radio.Group onChange={onChange} value={value}>
                {type === CREATE_TOWER_PROJECT && (
                  <>
                    <Radio value={2}>新建通天塔项目</Radio>
                    <Radio value={1}>关联已有通天塔项目ID</Radio>
                  </>
                )}
                {type === CHANGE_TOWER_PROJECT && (
                  <>
                    <Radio value={1}>更换通天塔项目</Radio>
                    <Radio value={2}>新建通天塔项目</Radio>
                    <Radio value={3}>取消关联当前项目</Radio>
                  </>
                )}
              </Radio.Group>
            </Form.Item>
          }
          {value === 1 && (
            <>
              <Form.Item
                label="通天塔项目ID"
                name="towerId"
                rules={[
                  {
                    required: true,
                    message: '请关联通天塔项目',
                  },
                  {
                    validator: (_: any, val: any) => {
                      return new Promise((resolve, reject) => {
                        apis
                          .validTowerId({
                            towerId: val,
                            type: 2,
                          })
                          .then(({ ret, msg, data }: any) => {
                            if (ret === '0') {
                              if (data?.isValid) {
                                setErrorMessage(false);
                                return resolve('');
                              } else {
                                setErrorMessage(true);
                                setErrorInfo({
                                  roomName: data.roomName,
                                  roomId: data.roomId,
                                  owner: data.owner,
                                });
                                return reject(new Error(' '));
                              }
                            } else {
                              message.error(msg);
                              return reject(new Error(' '));
                            }
                          })
                          .catch((e) => {
                            console.log(e);
                          });
                      });
                    },
                  },
                ]}
              >
                <Select
                  style={{ width: 400 }}
                  placeholder="请选择名下的通天塔项目ID"
                  showSearch
                  onSearch={__.debounce(handleSearch, 200)}
                  filterOption={false}
                >
                  {towerList.map((item: any, key: any) => (
                    <Option key={item.towerId} value={item.towerId}>
                      项目ID: {item.towerId} 项目名称:{item.towerName}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              {errorMessage && (
                <div className="create-tower-project__warning-wrapper">
                  <span className="create-tower-project__warning">
                    该项目已关联
                    <u className="create-tower-project__copy">
                      {errorInfo.roomName}（ID：
                      <Copy text={errorInfo.roomId} iconStyle={{ color: '#2d64ff' }} />）
                    </u>
                    ，请联系活动管理员
                    <span
                      className="creat-tower-project__owner"
                      onClick={() => {
                        window.location.href = 'timline://chat/?topin=' + errorInfo.owner;
                      }}
                    >
                      {errorInfo.owner}
                      <img
                        style={{ margin: '0 5px' }}
                        width={14}
                        height={14}
                        src="//img12.360buyimg.com/imagetools/jfs/t1/210595/7/7816/1474/6180de6fEf8d247f0/7824964323d5d56d.png"
                      />
                    </span>
                    进行解绑。
                    <u
                      className="create-tower-project__how"
                      onClick={() => {
                        window.open(env.ACORE_DOMAIN + '/help/list/63?type=2&categoryIds=3');
                      }}
                    >
                      如何解绑？
                    </u>
                  </span>
                </div>
              )}
            </>
          )}
          {value === 2 && <CreateItem />}
        </Form>
      </Modal>
    </>
  );
}

export default CreateTowerProject;
